var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEgale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 238 216",
    style: {
      enableBackground: "new 0 0 238 216"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.egal0{fill:#39003C;}\n\t.egal1{fill:#FFFFFF;}\n\t.egal2{fill:#FDCBC7;}\n\t.egal3{fill:#F0ACAE;}\n\t.egal4{fill:#FFF3F3;}\n\t.egal5{fill:#3E0040;}\n\t.egal6{fill:#330434;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000039110782964683496330000006262059006928219539_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_17"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "egal0",
    cx: 119.3,
    cy: 110.9,
    r: 90
  }), /*#__PURE__*/React.createElement("path", {
    className: "egal1",
    d: "M119.3,204.9c-51.8,0-94-42.2-94-94s42.2-94,94-94s94,42.2,94,94S171.2,204.9,119.3,204.9z M119.3,24.9 c-47.4,0-86,38.6-86,86s38.6,86,86,86s86-38.6,86-86S166.8,24.9,119.3,24.9z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2_00000089556903178928707820000014732581857173055884_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "egal2",
    points: "146.4,101.5 137.8,128 134,131 123.6,139.2 116.7,144.7 98.7,144.7 80.5,134.8 78.7,131 78.3,130.2  76.8,127 76.3,125.8 75.2,123.5 74.8,122.6 72.5,117.8 71.9,116.6 71.5,115.7 61.4,114 61,113.5 60.4,112.7 58.2,109.8  57.6,108.9 55,105.5 54.2,104.3 53.5,103.4 53.5,88.1 53.6,87.9 54.5,86.7 56.7,83.7 57.3,82.9 58.8,80.8 58.8,59.5 59,59.1  59.3,58.3 60.7,55.1 61,54.3 62.3,51.3 62.7,50.5 64.2,46.9 64.5,46.1 65.5,43.9 65.8,43.1 66,42.6 67.7,40.8 68.5,40 71.9,36.5  73,35.3 75.4,32.9 76.2,32.1 78.2,30 79.3,28.8 81.3,26.8 81.9,26.2 82.3,26.1 84.3,25.6 98.7,21.8 106,23 116.3,24.6 136.9,41.1  145,70.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal3",
    points: "123.6,139.2 116.7,144.7 98.7,144.7 80.5,134.8 78.7,131 78.3,130.2 76.8,127 76.3,125.8 75.2,123.5  74.8,122.6 72.5,117.8 71.9,116.6 71.5,115.7 61.4,114 61,113.5 60.4,112.7 58.2,109.8 57.6,108.9 55,105.5 54.2,104.3  53.5,103.4 53.5,88.1 53.6,87.9 54.5,86.7 56.7,83.7 57.3,82.9 58.8,80.8 58.8,59.5 59,59.1 59.3,58.3 60.7,55.1 61,54.3  62.3,51.3 62.7,50.5 64.2,46.9 64.5,46.1 65.5,43.9 65.8,43.1 66,42.6 67.7,40.8 68.5,40 71.9,36.5 73,35.3 75.4,32.9 76.2,32.1  78.2,30 79.3,28.8 81.3,26.8 81.9,26.2 82.3,26.1 82,26.8 81.1,28.8 80.5,30 79.6,32.1 79.2,32.9 78.1,35.3 77.5,36.5 75.9,40  75.5,40.8 74.5,43.1 74.1,43.9 73.1,46.1 72.7,46.9 71.1,50.5 70.7,51.3 70,52.8 70,83.3 70.3,83.7 71.8,86.7 72.5,87.9  74.1,90.9 74.7,92.1 76.5,95.5 76.9,96.3 78.9,100.1 79.1,100.5 81.1,104.3 81.7,105.5 84.7,111 85.5,112.7 86,113.5 87.7,116.6  88.3,117.8 90.9,122.6 91.4,123.5 92.7,125.8 93.1,126.6 96.7,133.3 114.2,141.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal4",
    points: "146.4,101.5 137.8,128 134,131 137.4,99 139.4,69.8 126.8,40.8 106,23 116.3,24.6 136.9,41.1  145,70.7  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 58.8,
    y: 65.8,
    className: "egal5",
    width: 24.4,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.8,
    y: 79.4,
    className: "egal5",
    width: 17.7,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "81.9,86.7 81.9,87.9 53.6,87.9 54.5,86.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 90.9,
    className: "egal5",
    width: 31,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 99.2,
    className: "egal5",
    width: 19.7,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "93.1,116.6 93.1,117.8 72.5,117.8 71.9,116.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "84.5,104.3 84.5,105.5 55,105.5 54.2,104.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "93.1,125.8 93.1,127 76.8,127 76.3,125.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "89.9,35.3 89.9,36.5 71.9,36.5 73,35.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "93.1,28.8 93.1,30 78.2,30 79.3,28.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "99,25.6 99,26.8 81.3,26.8 81.9,26.2 82.3,26.1 84.3,25.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.8,
    y: 61.5,
    className: "egal5",
    width: 21.6,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "83.2,58.3 83.2,59.1 59,59.1 59.3,58.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "85.3,54.3 85.3,55.1 60.7,55.1 61,54.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "88.8,50.5 88.8,51.3 62.3,51.3 62.7,50.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.8,
    y: 69.2,
    className: "egal5",
    width: 22,
    height: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "74.6,82.9 74.6,83.7 56.7,83.7 57.3,82.9  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.6,
    y: 95.5,
    className: "egal5",
    width: 28.3,
    height: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "58.2,109.8 83,109.8 83,108.9 57.6,108.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "91.6,130.2 91.6,131 78.7,131 78.3,130.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "97.9,122.6 97.9,123.5 75.2,123.5 74.8,122.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "93.1,112.7 93.1,113.5 61,113.5 60.4,112.7  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.3,
    y: 119.8,
    className: "egal5",
    width: 9.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.7,
    y: 105.6,
    className: "egal5",
    width: 4.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78.5,
    y: 100.1,
    className: "egal5",
    width: 4.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.9,
    y: 96.4,
    className: "egal5",
    width: 4.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 83.9,
    className: "egal5",
    width: 4.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77,
    y: 80.8,
    className: "egal5",
    width: 4.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.8,
    y: 59.5,
    className: "egal5",
    width: 4.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.9,
    y: 84.8,
    className: "egal5",
    width: 2.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.8,
    y: 62.5,
    className: "egal5",
    width: 2.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.4,
    y: 55.5,
    className: "egal5",
    width: 2.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.2,
    y: 51.6,
    className: "egal5",
    width: 2.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.2,
    y: 46.9,
    className: "egal5",
    width: 2.9,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.5,
    y: 43.9,
    className: "egal5",
    width: 4.6,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.8,
    y: 73,
    className: "egal5",
    width: 25,
    height: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.8,
    y: 76.2,
    className: "egal5",
    width: 19.8,
    height: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "79.1,46.1 79.1,46.9 64.2,46.9 64.5,46.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "79.9,43.1 79.9,43.9 65.5,43.9 65.8,43.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "89.5,40 89.5,40.8 67.7,40.8 68.5,40  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "95.9,32.1 95.9,32.9 75.4,32.9 76.2,32.1  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "egal5",
    d: "M63.7,108.8c0,0,4.1-1,4-7.5c-0.1-6.4-8.5-11.7-10.4-9.7s6.3,4.7,5.9,8.4C62.7,103.7,59.4,109.9,63.7,108.8 L63.7,108.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1169",
    className: "egal6",
    d: "M121,93.3c0.6,0.8,1.1,1.6,1.5,2.4c0.5,0.8,0.9,1.7,1.3,2.5l0.1,0.2v0.1 c0,0.1,0.1,0.1,0.1,0.2c0.1,0.3,0.1,0.5,0.1,0.8c-0.1,0.4-0.2,0.7-0.4,1.1c-0.3,0.5-0.6,0.9-1.1,1.3c-0.7,0.7-1.6,1.3-2.5,1.7 l-0.6-0.8c0.5-0.8,1.1-1.5,1.7-2.2c0.2-0.3,0.4-0.7,0.6-1c0-0.1,0.1-0.2,0.1-0.3v0.1c0,0,0,0,0,0.1c0,0,0,0,0-0.1l-0.1-0.2 c-0.4-0.9-0.8-1.8-1.1-2.7c-0.3-0.9-0.6-1.8-0.8-2.8L121,93.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1172",
    className: "egal6",
    d: "M100.8,79.3c0.6-0.9,1.7-1.3,2.8-1.1c2,0.3,2.7,1.5,2.1,3c-0.5,1.5-1.4,2-2.2,1.5 c-0.8-0.5-1.2-0.6-1-2.6c-1.2,0-2.2,0.6-2.1,0.2C100.5,80,100.7,79.6,100.8,79.3L100.8,79.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1173",
    className: "egal6",
    d: "M127.9,79.3c0.6-0.9,1.8-1.3,2.9-1.1c2,0.3,2.7,1.5,2.2,3s-1.4,2-2.2,1.6s-1.2-0.6-1-2.6 c-1.2,0-2.2,0.6-2.2,0.2C127.6,80,127.7,79.6,127.9,79.3L127.9,79.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1175",
    className: "egal0",
    d: "M124.7,72.6c0,0,6.9-2.1,10.6-1.6c1.9,0.1,3.7,0.7,4.9,1.6H124.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1176",
    className: "egal0",
    d: "M93.1,72.9c0,0,8-3.1,12.7-2.5c2.4,0.1,4.7,0.9,6.4,2.2L93.1,72.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal3",
    points: "127.5,162.1 119.5,171 95.4,169.3 88,160.6 87,159.4 84.8,156.7 84.5,156.4 84.5,155.9 84.5,153.8  84.6,152.6 84.6,149.8 84.6,148.9 84.6,145.3 84.6,144.1 84.7,137.1 84.7,134.6 91.4,140.8 103.2,151.4 125.5,150.3  "
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "egal1",
    cx: 119.9,
    cy: 116,
    rx: 5.6,
    ry: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 144.1,
    className: "egal5",
    width: 7.3,
    height: 1.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "100.7,152.6 100.7,153.8 84.5,153.8 84.6,152.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "99.1,159.4 99.1,160.6 88,160.6 87,159.4  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.6,
    y: 148.9,
    className: "egal5",
    width: 11.8,
    height: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "egal5",
    points: "92.6,155.9 92.6,156.7 84.8,156.7 84.5,156.4 84.5,155.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "egal1",
    d: "M156.9,112.7c0-6.7,5.5-6.8,6.4-6.8c1,0,6.4,0.2,6.4,6.8c0,6.7-5.4,6.7-6.4,6.7 C162.4,119.5,156.9,119.4,156.9,112.7z M167.6,112.7c0-4.5-3.5-4.8-4.2-4.8s-4.3,0-4.3,4.8s3.5,4.7,4.3,4.8 C164.1,117.5,167.6,117.7,167.6,112.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "egal1",
    d: "M180.1,109.1l-4.7,4l4.7,6.2h-2.6l-3.7-4.9l-0.7,0.6v4.3H171V106h2.1v6.6l4.1-3.6h2.9V109.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgale);
export default __webpack_public_path__ + "static/media/egale.acfe50dc322605ee6c3548c4a0d9e1af.svg";
export { ForwardRef as ReactComponent };